export const DATA_POINT_STATE = {
    "start": 0,
    "fin": 1,
    "warn": 2,
    "incongruous": 3
};
export const MES_KEY_STAGE = {
    "default": 0,
    "start": 1,
    "mockStart": 2,
    "beforeMes": 2,
    "fin": 4,
    "exp": 5,
    "end": 5,
};
const mesStageMap = {
    0: {
        sequenceId: NaN,
        text: "Nespecifikovaný stav",
        stycky: false,
    },
    1: {
        sequenceId: 0,
        text: 'Nevalidované čidlo',
        stycky: true,
    },
    2: {
        sequenceId: 1,
        text: "Založeno",
        stycky: true,
    },
    3: {
        sequenceId: 2,
        text: "Rozpraconáno",
        stycky: true,
    },
    4: {
        sequenceId: 3,
        text: "Uzamknuto",
        stycky: true,
    },
    5: {
        sequenceId: 4,
        text: "Exportováno",
        stycky: true,
    }
};
export const ENV_HW_META_KEYS = {
    'hwStandart': 1,
    'location': 2
};
export const ENV_HW_KEYS = {
    "owen": 1,
    "wika": 2,
    "etalon": 3,
    "location": 4,
};
const envHwTypeMap = {
    0: {
        name: "unknown",
        metaDataType: 0,
    },
    1: {
        name: "owen",
        metaDataType: 1,
    },
    2: {
        name: "wika",
        metaDataType: 1,
    },
    3: {
        name: "etalon",
        metaDataType: 1,
    },
    4: {
        name: "location",
        metaDataType: 2,
    }
};
export const MES_STAGE_MAP = genProxy(mesStageMap, 0);
export const MES_STAGE_MAP_KEYS = Object.keys(MES_STAGE_MAP);
export const ENV_HW_TYPE_MAP = genProxy(envHwTypeMap, 0);
export const ENV_HW_TYPE_MAP_KEYS = Object.keys(ENV_HW_TYPE_MAP);
function genProxy(srcObj, defaultKey) {
    return new Proxy(srcObj, {
        get: function (target, prop, _) {
            /* if (prop === 'asKeyList') {
                return
            } else  */ if (prop in target) {
                return target[prop];
            }
            else {
                console.log("[WARN - key not found in enum]:", prop, target);
                return target[defaultKey];
            }
        }
    });
}
